<template>
    <div>
        <div class="saving" v-if="saving">
            <LoadingSpinner :loading="saving"/>
        </div>
        <div class="loading" v-if="loading">
            <LoadingSpinner :loading="loading"/>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <Calculation v-model="calculation" :edit="true" :create="false"></Calculation>
            </div>
            <div class="col-12 text-center mt-3 mb-3">
                <button class="btn btn-primary" @click="save">Uložit</button>
            </div>
        </div>
    </div>
</template>

<script>
import Calculation from '@/components/Calculation.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
export default {
    components: {
        Calculation,
        LoadingSpinner
    },
    data() {
        return {
            calculation: {},
            saving: false,
            loading: true
        }
    },
    created: function () {
        if (this.$route.params.id) {
            this.load();
        }
        else {
            this.$router.push({ name: "templates" });
        };
    },
    methods: {
        load: function () {
            this.loading = true;
            this.$store.getters.api.get("/template/" + this.$route.params.id + "/premade").then(function (response) {
                this.calculation = response.data;
                this.loading = false;
            }.bind(this))
        },
        save: function () {
            this.saving = true;
            this.$store.getters.api.post("/calculation/create",
                {"calculation": this.calculation, "templateId": this.$route.params.id}
            ).then(function () {
                this.saving = false;
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>